import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar";
import AdminDashboardHeader from "../admin/header/header";
import AdminDashboardSidebar from "../admin/sidebar/sidebar";
import { Routes, Route } from "react-router-dom";
import Settings from "./settings/setting";
import AdminProfile from "./profile/profile";
import AdminUsers from "./user/users";
import AdminLibrary from "./library/library";
import AdminMediaUpload from "./library/upload";
import Overview from "./overview/overview";
import Productslist from "./products/product-listing";
import ProductCreate from "./products/products-create";
import ProductEdit from "./products/products-edit";
import Orders from "./orders/orders";
import OrderDetails from "./orders/order-details";
import CreateOrder from "./orders/create-order";
import UpdateTracking from "./orders/update-tracking";
import SupportTickets from "./support/tickets";
import TicketDetails from "./support/ticket-details";
import CreateBlog from "./blog/create-blog";
import EditBlog from "./blog/edit-blog";
import SendMail from "./sendmail/sendmail";
import BlogList from "./blog/list-blog";
import CouponManagement from "./coupon/coupon-management";
import AdminBlogComments from "./blog/comments";
import Returns from "./returns/returns";
import ReturnDetails from "./returns/return-details";
import AboutUsManagement from "./about/about-us";
import ReviewsManagement from "./reviews/reviews";
import LegalPagesManagement from "./legal/legal-pages";
import FAQManagement from "./faq/faq-management";
import Transactions from "./transactions/transactions";
import AdminReferralManagement from "./referrals/AdminReferralManagement";
import AllAdminsLoginHistory from "./login-history/all-login-history";
import ActivityLog from "./activity-log/activity-log";
import ActivityLogDetails from "./activity-log/activity-log-details";
// import SkinScans from "./skin-scans/skin-scans";

export default function AdminDashboardLayout() {
  return (
    <SidebarProvider defaultOpen={true}>
      <AdminDashboardSidebar />
      <SidebarInset>
        <AdminDashboardHeader />
        <main className="flex flex-1 flex-col gap-4 p-4 md:gap-8 md:p-6 overflow-x-hidden min-w-0">
          <Routes>
            <Route path="overview" element={<Overview />} />
            <Route path="mail" element={<SendMail />} />
            <Route path="profile" element={<AdminProfile />} />
            <Route path="library" element={<AdminLibrary />} />
            <Route path="library/upload" element={<AdminMediaUpload />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="blog/create" element={<CreateBlog />} />
            <Route path="blog/edit/:slug" element={<EditBlog />} />
            <Route path="blog/list" element={<BlogList />} />
            <Route path="blog/comments" element={<AdminBlogComments />} />
            <Route path="products/create" element={<ProductCreate />} />
            <Route path="products/list" element={<Productslist />} />
            <Route path="products/edit/:productId" element={<ProductEdit />} />
            <Route path="coupons" element={<CouponManagement />} />
            <Route path="orders/list" element={<Orders />} />
            <Route path="orders/create" element={<CreateOrder />} />
            <Route path="orders/:orderId" element={<OrderDetails />} />
            <Route
              path="orders/:orderId/tracking"
              element={<UpdateTracking />}
            />
            <Route path="support" element={<SupportTickets />} />
            <Route path="support/:id" element={<TicketDetails />} />
            <Route path="returns" element={<Returns />} />
            <Route path="returns/:returnId" element={<ReturnDetails />} />
            <Route path="about" element={<AboutUsManagement />} />
            <Route path="reviews" element={<ReviewsManagement />} />
            <Route path="legal" element={<LegalPagesManagement />} />
            <Route path="faq" element={<FAQManagement />} />
            <Route path="transactions" element={<Transactions />} />
            <Route path="referrals" element={<AdminReferralManagement />} />
            <Route path="login-history" element={<AllAdminsLoginHistory />} />
            <Route path="activity-log" element={<ActivityLog />} />
            <Route path="activity-log/:id" element={<ActivityLogDetails />} />
            {/* <Route path="skin-scans" element={<SkinScans />} /> */}
            <Route path="settings" element={<Settings />} />
            <Route path="*" element={<Overview />} />
            {/* Add more admin routes here if needed */}
          </Routes>
        </main>
      </SidebarInset>
    </SidebarProvider>
  );
}
